export function getImageWithCertainResolution({
  screenWidth,
  banner,
}: {
  screenWidth: number
  banner: any
}) {
  if (screenWidth > 1120) {
    return banner?.images?.desktop ? (
      <img
        src={banner?.images?.desktop}
        className="banner_img"
        style={{ minHeight: 520, maxHeight: 520 }}
        alt={banner?.title?.text}
      />
    ) : (
      <div style={{ minHeight: 520, maxHeight: 520 }} />
    )
  }

  if (screenWidth > 480 && screenWidth <= 1120) {
    return banner?.images?.tablet ? (
      <img
        src={banner?.images?.tablet}
        className="banner_img"
        style={{ minHeight: 386, maxHeight: 386 }}
        alt={banner?.title?.text}
      />
    ) : (
      <div style={{ minHeight: 386, maxHeight: 386 }} />
    )
  }

  return banner?.images?.mobile ? (
    <img
      src={banner?.images?.mobile}
      className="banner_img"
      style={{ minHeight: 258, maxHeight: 258 }}
      alt={banner?.title?.text}
    />
  ) : (
    <div style={{ minHeight: 258, maxHeight: 258 }} />
  )
}
